import Vue from 'vue'
import Vuex from 'vuex'
import sacola from "../../../pages/Sacola";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dataUser: {},
    empresa: {
      agendamentos: []
    },
    empresaAberta: false,
    zap: null,
    unidades: [],
    sacola: { produtos: [] },
    nolocal: { obs_pedido: '', onde_estou: '' },
    cardapio: {
      categorias: [],
      destaques: [],
      url: '/',
    },
    cidade: {},
    load: false,
    modalPush: 0,
    cartao_pagamento: null,
    url: '',
    beneficios: [],
    recomendados: [],
    saldoFidelidade: null,
    timeSync: null,
    pontosSacola: 0,
    id_theme: '1',
    taxa: null
  },

  mutations: {
    setDataUser: (state, data) => {
      const dados = data.dados;

      localStorage.setItem(state.empresa.dominio_delivery, data.token);
      localStorage.setItem('token', data.token);

      state.dataUser = dados;
      state.cidade = {
        id_cidade: dados.id_cidade,
        nome_cidade: dados.nome_cidade,
        sigla_estado: dados.sigla_estado
      }
    },

    logout(state) {
      localStorage.removeItem('sacola');
      localStorage.removeItem('nolocal');
      localStorage.removeItem('token');
      localStorage.removeItem(state.empresa.dominio_delivery);
      state.saldoFidelidade = null;
      state.zap = null;
      state.dataUser = {};
      state.sacola = { produtos: [] };
    },

    setEmpresa: (state, data) => {
      state.empresa = data;
      state.base_url = data.server + data.token + '/';
      state.empresa.zonas = (data.zonas || []);
      const cartao = (data.pagamentos || []).find(pag => ['30', '32'].includes(pag.id_pagamento));
      state.cartao_pagamento = cartao ? cartao.id_pagamento : null;
    },

    setProdutosSacola(state, data) {
      let total = 0;
      let pontos = 0;

      if (data.token !== state.empresa.token) {
        let expiracao = state.nolocal.expiracao || (new Date().getTime() + ((1000 * 60 * 60) * 24));
        state.sacola = {
          token: state.empresa.token,
          empresa: state.empresa.nome_fantasia,
          dominio_delivery: state.empresa.dominio_delivery,
          origin: data.origin || null,
          nolocal: data.nolocal || null,
          produtos: data.produtos,
          cliente: {},
          id_pagamento: '',
          tipo_pedido: '',
          valor_frete: 0,
          id_cupom: '',
          total: 0,
          troco: 0,
          obs_pedido: '',
          expiracao
        }
      }

      state.sacola.produtos.forEach(p => {
        total += (p.quantidade * parseFloat(p.valor));
        pontos += (!isNaN(p.pontos) ? parseInt(p.pontos) : 0);
      });

      state.sacola.total = total;
      state.pontosSacola = pontos;
      localStorage.setItem('sacola', JSON.stringify(state.sacola));
    },

    clearSacola(state) {
      state.sacola.produtos = [];
      state.sacola.origin = '5';
    }
  },

  actions: {
  },
  modules: {
  }
})
